import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { find, get, includes, isNil } from 'lodash';
import { useHistory, useLocation } from 'react-router-dom';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

import { INF_ERROR_CODES, STEPS, USERNAME_CRITERIA } from '../utilities/constants';
import {
    buyInfince,
    setStepNumber,
    setBusinessMailError,
    setGetDomainError,
    setBusinessMailVerifyError,
    setStripeErrorMessage,
    processCard,
    trackEvent as trackEventAction,
    saveTempUrl, setMailPasswordError
} from '../store/signup/signupAction';
import { validUsername } from '../utilities/validations';

/**
 * Footer component
 * @param {*} param0
 */
const Footer = ({
    currentStep,
    submit,
    menu,
    otpVerified,
    planDetails,
    signupDetails,
    setStepNumber,
    buyInfince,
    basicData,
    domainName,
    businessMail,
    setShowLoader,
    setBusinessMailError,
    cardData,
    domainDetails,
    domainPageData,
    setGetDomainError,
    needMailServer,
    businessMailVerified,
    accPassword,
    needDomain,
    setBusinessMailVerifyError,
    setStripeErrorMessage,
    processCard,
    trackEvent,
    saveTempUrl, setMailPasswordError
}) => {
    const history = useHistory();
    const location = useLocation();
    const stripe = useStripe();
    const elements = useElements();

    const [disableBuyInfince, setDisableBuyInfin] = useState(false);
    useEffect(() => {
        const step = find(STEPS, (step) => {
            return step.route === location.pathname.split(/[/ ]+/).pop();
        });

        setStepNumber(get(step, 'step_no', 0));
    }, [location.pathname, setStepNumber]);
    /**
     * riggers when verification is completed
     */
    const verificationComplete = () => {
        if (otpVerified) {
            currentStep && !isNaN(currentStep) && setStepNumber(currentStep + 1);
            history.push(`/registration/${get(menu, '2.route', '')}`);
        }
    };
    /**
     * to validte the basic plan selection
     */
    const validateBasicPlanDetails = () => {
        if (validUsername(businessMail) !== undefined) {
            setBusinessMailError(true);
            return true;
        } else if (!isNil(planDetails) && businessMail) {
            return false;
        } else if (!businessMail) {
            setBusinessMailError(true);
        }
        return true;
    };
    /**
     * Check if password is not empty string
     */
    const passwordExists = () => {
        if (accPassword !== '') {
            setMailPasswordError(false);
            return false;
        }
        setMailPasswordError(true);
        return true;
    };
    /**
     * checks is business mail is verified
     */
    const businessMailVerification = () => {
        const error = !businessMailVerified;
        setBusinessMailVerifyError(!businessMailVerified);
        return error;
    };
    /**
     * Proceed to payments section function
     */
    const proceedToPayment = () => {
        let errors = false;
        if (needDomain) {
            //needs domain and mailserver - no password needed
            errors = validateBasicPlanDetails();
        } else if (!needMailServer) {
            //donot need mail server and domain - request password
            errors =
                validateBasicPlanDetails() ||
                businessMailVerification()
        } else {
            errors = validateBasicPlanDetails() || passwordExists();

            //need mail server only -request password
        }

        trackEvent(process.env.REACT_APP_TRACKER_NORMAL_SIGNUP_STEP_3_ENDPOINT_ID, {
            plan: get(planDetails, 'flavor.label', ''),
            description: get(planDetails, 'flavor.description', ''),
            storage: get(planDetails, 'storage', ''),
            users: get(planDetails, 'users', ''),
            firstName: get(basicData, 'first_name', ''),
            lastName: get(basicData, 'last_name', ''),
            email: get(basicData, 'email', ''),
            formId: get(basicData, 'form_id', ''),
        });

        if (!errors) {
            history.push(`/registration/${STEPS.CHOOSE_PLAN.next}`);
        }
    };
    /**
     * Renders the signup button
     * @param {*} submit
     */
    const renderSignupButton = (submit) => {
        return (
            <>
                <button
                    type="button"
                    className="btn-primary"
                    onClick={() => submit('signup')}
                >
                    Sign Up & Proceed
                </button>
            </>
        );
    };
    /**
     * Final submission for infince
     */
    const completeInfince = async () => {
        setDisableBuyInfin(true);
        // Block native form submission.
        setShowLoader(true);

        // setDisableButton(true);

        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            // setDisableButton(false);
            setShowLoader(false);
            setDisableBuyInfin(false);
            return;
        }

        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const cardElement = elements.getElement(CardElement);

        // Use your card Element with other Stripe.js APIs
        const { error, token } = await stripe.createToken(cardElement);

        if (error) {
            setShowLoader(false);
            setDisableBuyInfin(false);
        } else {
            processCard(token);
            if (token) {
                setShowLoader(true);
                const formData = {
                    userCount: get(planDetails, 'users', 10),
                    flavorId: get(planDetails, 'flavor.value'),
                    starter: get(planDetails, 'starter', false),
                    flavorName: get(planDetails, 'flavor.label'),
                    storage: get(planDetails, 'storage', 20),
                    businessName: get(domainDetails, 'businessName', ''),
                    businessTypes: get(domainDetails, 'businessTypes', []).map(
                        (elem) => {
                            return {
                                item_id: elem.value,
                                item_text: elem.label,
                            };
                        }
                    ),
                    businessMail: businessMail,
                    domainName: domainName,
                    haveCoupon: 'no',
                    stripeId: token.id,
                    cardToken: token.card.id,
                    adminUserName: businessMail,
                    domainDetails: get(domainPageData, 'formData', {}),
                    password: accPassword,
                    formID: basicData.form_id,
                };

                buyInfince(formData, basicData.form_id).then((res) => {
                    setShowLoader(false);
                    setDisableBuyInfin(false);
                    const errorArray = [];

                    if (res.status === 'success') {
                        saveTempUrl(get(res, 'url'));
                        let redirectURL = '/completed';
                        if (needDomain) {
                            redirectURL = redirectURL + '/domain'

                        } else if (needMailServer) {
                            redirectURL = redirectURL + '/email'
                        }
                        history.push(redirectURL);
                        trackEvent(process.env.REACT_APP_TRACKER_NORMAL_SIGNUP_STEP_4_ENDPOINT_ID, {
                            haveCoupon: get(formData, 'haveCoupon', ''),
                            firstName: get(basicData, 'first_name', ''),
                            lastName: get(basicData, 'last_name', ''),
                            email: get(basicData, 'email', ''),
                            formId: get(basicData, 'form_id', ''),
                        });
                    } else if (
                        res.status === 'failed' ||
                        res.status === 'fail' || res.status === 422
                    ) {
                        if (get(res, 'msg') === 'Domain already registered') {
                            // redirect to domain purchase section
                            setGetDomainError(
                                INF_ERROR_CODES.INF_DOMAIN_REGISTERED
                            );
                            history.push(
                                `/registration/${get(menu, '2.route')}`
                            );
                        } else if (get(res, 'msg') === USERNAME_CRITERIA) {
                            setBusinessMailError(true);
                            history.push(`/registration/${STEPS.GET_DOMAIN.next}`);
                        }

                        if (get(res, 'body.code') === 'INVALID_BODY') {
                            get(res, 'body.fields').forEach((field) => {
                                const fieldValue = field.path
                                    .split(/[. ]+/)
                                    .pop();
                                if (!includes(errorArray, fieldValue)) {
                                    errorArray.push(fieldValue);
                                }
                            });
                            setGetDomainError(errorArray);

                            history.push(`/registration/get-domain`);
                        }
                        if (includes(get(res, 'msg'), 'stripe')) {
                            setStripeErrorMessage(
                                'Your credit card was declined. Please try a different card.'
                            );
                        }
                        if (get(res, 'message')) {
                            setStripeErrorMessage(get(res, 'message'));
                        }
                    }
                });
            }
        }
    };
    /**
     * Renders the proceed button
     * @param {*} submit
     */
    const renderWizardProceedButton = (submit) => {
        switch (location.pathname) {
            case '/registration/validate':
                return (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => verificationComplete()}
                    >
                        Next
                    </button>
                );
            case '/registration/get-domain':
                return (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => submit('signup')}
                    >
                        Next
                    </button>
                );
            case '/registration/domain-details':
                return (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => submit('domainDetails')}
                    >
                        Next
                    </button>
                );
            case '/registration/choose-plan':
                return (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => proceedToPayment()}
                    >
                        Next
                    </button>
                );
            case '/registration/payment':
                return (
                    <button
                        type="button"
                        className="btn-primary"
                        onClick={() => completeInfince()}
                        disabled={disableBuyInfince}
                    >
                        Setup InfinCE
                    </button>
                );
            default:
                return null;
        }
    };
    return (
        <footer className="footer">
            <div className="container">
                <div className="steps-count">
                    Step <strong>{currentStep}</strong> / 5{' '}
                </div>
                {currentStep === 1
                    ? renderSignupButton(submit)
                    : renderWizardProceedButton(submit)}
            </div>
        </footer>
    );
};

const mapStateToProps = (store) => ({
    currentStep: store.signupReducer.currentStep,
    otpVerified: get(store, 'signupReducer.otpVerified'),
    menu: get(store, 'menuReducer.navMenu', []),
    planDetails: get(store, 'signupReducer.planDetails'),
    basicData: get(store, 'signupReducer.basicData'),
    signupDetails: get(store, 'signupReducer'),
    businessMail: get(store, 'signupReducer.businessMail'),
    domainName: get(store, 'signupReducer.needDomain')
        ? get(store, 'signupReducer.getDomain.domainDetails.domain', '')
        : get(store, 'signupReducer.domainDetails.businessDomain', ''),
    cardData: get(store, 'signupReducer.cardData'),
    domainDetails: get(store, 'signupReducer.needDomain')
        ? get(store, 'signupReducer.getDomain', '')
        : get(store, 'signupReducer.domainDetails', ''),
    domainPageData: get(store, 'signupReducer.getDomain', null),
    needMailServer: get(store, 'signupReducer.needMailServer', true),
    needDomain: get(store, 'signupReducer.needDomain', true),
    businessMailVerified: get(
        store,
        'signupReducer.businessMailVerified',
        false
    ),
    accPassword: get(store, 'signupReducer.accPassword', ''),
});
const mapDispatchToProps = {
    submit,
    setStepNumber,
    buyInfince,
    trackEvent: trackEventAction,
    setBusinessMailError,
    setGetDomainError,
    setBusinessMailVerifyError,
    setStripeErrorMessage,
    processCard,
    saveTempUrl, setMailPasswordError
};

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
